import React from 'react'
import { MdOutlineTimer } from 'react-icons/md';
import { useTimer } from 'react-timer-hook';

function Timer({bidEnd}) {

    const expiryTimestamp = new Date(bidEnd);
  console.log(expiryTimestamp);
  
  const { seconds, minutes, hours, days } = useTimer({
    expiryTimestamp,
    onExpire: () => console.warn("onExpire called"),
  });
  return (
    <div className="flex items-center gap-3">
    <div className="bg-[#74B5FF0D] border-[#F6F8FF] rounded-full">
      <MdOutlineTimer
        className="  p-3   w-11 h-11" />
    </div>
    <div>
      <p className="text-[14px] font-normal text-[#0000008C]"> Ending In</p>
      <p className="text-[16px] font-medium text-[#000000D9] pt-1">{days} D : {hours} H : {minutes} M : {seconds} S</p>
    </div>
  </div>
  )
}

export default Timer